document.addEventListener('DOMContentLoaded',()=>{
  const ship=document.querySelector('.mpd-trust3__item--ship .mpd-trust3__copy span');
  const secure=document.querySelector('.mpd-trust3__item--secure .mpd-trust3__copy span');
  const selected=document.querySelector('.mpd-trust3__item--selected .mpd-trust3__copy span');
  if(ship) ship.textContent='Cobertura según destino';
  if(secure) secure.textContent='Opciones al finalizar compra';
  if(selected) selected.textContent='Catálogo organizado';
  const legacy=document.querySelector('.v5-solutions');
  if(legacy) legacy.remove();
  const brands=document.querySelector('.mpd-brands5, .v5-brands');
  if(brands){
    brands.id='marcas';
    brands.style.scrollMarginTop='24px';
    if(window.location.hash==='#marcas') setTimeout(()=>brands.scrollIntoView({behavior:'smooth',block:'start'}),80);
  }
  if(!document.getElementById('mpd-gate8-shell')){
    const style=document.createElement('style');
    style.id='mpd-gate8-shell';
    style.textContent='.mpd-shell,.v5-inner,.mpd-trust3,.mpd-cat3,.mpd-featured4__inner,.mpd-brands5__head,.mpd-pay5,.v5-help,.mpd-footer6__shell{max-width:1168px!important}';
    document.head.appendChild(style);
  }
});

/* Gate 8: approved HD hero images */
document.addEventListener('DOMContentLoaded', () => {
  const heroes = [
    ['.mpd-hero2__slide--video .mpd-hero2__image','https://cdn.shopify.com/s/files/1/0512/6320/9647/files/mpd-hero-videovigilancia-hd.png?v=1789229875','Videovigilancia para hogares y negocios - Mi Punto Digital'],
    ['.mpd-hero2__slide--network .mpd-hero2__image','https://cdn.shopify.com/s/files/1/0512/6320/9647/files/mpd-hero-redes-hd.png?v=1789230482','Redes y conectividad para hogares y negocios - Mi Punto Digital'],
    ['.mpd-hero2__slide--energy .mpd-hero2__image','https://cdn.shopify.com/s/files/1/0512/6320/9647/files/mpd-hero-energia-hd.png?v=1789230492','Energía y protección para hogares y negocios - Mi Punto Digital'],
    ['.mpd-hero2__slide--access .mpd-hero2__image','https://cdn.shopify.com/s/files/1/0512/6320/9647/files/mpd-hero-control-acceso-hd.png?v=1789230502','Control de acceso para hogares y negocios - Mi Punto Digital']
  ];
  heroes.forEach(([selector, src, alt]) => {
    const img=document.querySelector(selector);
    if(!img) return;
    img.src=src;
    img.alt=alt;
    img.removeAttribute('srcset');
  });
});